<template>
    <div class="text-center p-4">
        <h2 class="fw-bold">{{ title }}</h2>
        <p class="text-dark mb-1">NEXT DRAW</p>

        <div class="d-flex justify-content-center mb-3">
  <div
    v-for="(digit, index) in countdownDigits"
    :key="index"
    class="digit-box"
    :class="{ 'group-gap': index === 1 || index === 3 }"
  >
    {{ digit }}
  </div>
</div>


        <!-- Static for now (can be formatted nicely later) -->
        <p class="text-dark mb-4 fw-bold">{{ formattedTime }} </p>

        <!-- Prizes -->
        <div class="result-card p-3 rounded-3 mx-auto" style="max-width: 400px; background: #f4f6fa;">
            <div v-for="(title, index) in ['First Place', 'Second Place', 'Third Place']" :key="index" class="mb-4">
                <div class="fw-bold text-secondary mb-2" style="font-style: italic;">{{ title }}</div>
                <div class="d-flex justify-content-center">
                    <div v-for="digit in getDigits(index)" :key="digit + index" class="result-ball mx-1">
                        <div class="p-1 result-ball-inside">{{ digit }}</div>
                    </div>
                </div>
                <hr class="my-2" style="border-top: 2px solid #ffc107; width: 80%; margin: auto;" />
            </div>
        </div>

        <router-link class="nav-link" :to="redirect">
            <a class="btn btn-primary mt-4" style="background: #1a3a7c;">See All Results</a>
        </router-link>
    </div>
</template>

<script>
import { ref, onMounted, onUnmounted } from "vue";

export default {
    name: "QuickCard",
    props: {
        data: {
            type: Object,
            required: true
        },
        title: String,
        redirect: { type: String, required: true },
    },
    setup(props) {
        const countdownDigits = ref(["0", "0", "0", "0", "0", "0"]);
        let timer = null;

        const updateCountdown = () => {
            const now = new Date();
            const target = new Date(props.data.nextDrawTime);
            const diff = Math.max(0, Math.floor((target - now) / 1000)); // seconds

            const hours = String(Math.floor(diff / 3600)).padStart(2, "0");
            const minutes = String(Math.floor((diff % 3600) / 60)).padStart(2, "0");
            const seconds = String(diff % 60).padStart(2, "0");

            countdownDigits.value = [...hours, ...minutes, ...seconds];
        };

        onMounted(() => {
            updateCountdown();
            timer = setInterval(updateCountdown, 1000);
        });

        onUnmounted(() => {
            clearInterval(timer);
        });

        const getDigits = (index) => {
            const key = index === 0 ? "result" : index === 1 ? "result2" : "result3";
            return String(props.data[key] ?? "").split("");
        };

        return {
            countdownDigits,
            getDigits,
        };
    },
    computed: {
        formattedTime() {
            const raw = this.data.datetime;
            if (!raw) {
                return `Period: ${this.data.period}`;
            }
            const date = new Date(raw);
            const options = {
                weekday: 'long',
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
            };
            const formatted = date.toLocaleString('en-US', options);
            const time = formatted.split(', ').pop();
            const [dayOfWeek, dateString] = formatted.split(', ').slice(0, 2);
            return `${dayOfWeek}, ${dateString} | ${time} Period: ${this.data.period}`;
        }
    }
};
</script>

<style scoped>
.digit-box {
    width: 40px;
    height: 50px;
    background-image: url('/public/assets/bg_timer.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;
    color: white;
    font-size: 24px;
    font-weight: bold;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    margin-right: 4px; /* Jarak antar digit default */
}

/* Tambahkan jarak ekstra setelah setiap grup (jam/menit) */
.group-gap {
    margin-right: 16px !important;
}

/* .result-ball {
    width: 40px;
    height: 40px;
    background-color: #1a3a7c;
    color: white;
    font-weight: bold;
    font-size: 20px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
} */

/* .result-ball-inside {
    transform: scale(1.1);
} */
</style>